// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Firebase from "../../backend/Firebase.bs.jsx";
import * as Reactfire from "../../backend/Reactfire.bs.jsx";
import * as Reactfire$1 from "reactfire";
import * as Auth from "firebase/auth";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Analytics from "firebase/analytics";
import * as AppCheck from "firebase/app-check";
import * as Functions from "firebase/functions";
import * as Messaging from "firebase/messaging";

function FirebaseAuthProvider(props) {
  let app = Reactfire$1.useFirebaseApp();
  let appCheck = AppCheck.initializeAppCheck(app, {
    provider: new AppCheck.ReCaptchaV3Provider(Firebase.appCheckToken),
    isTokenAutoRefreshEnabled: true
  });
  let auth = Auth.getAuth(app);
  auth.languageCode = "cs";
  let analytics = Analytics.getAnalytics(app);
  let functions = Functions.getFunctions(app, "europe-west3");
  let messaging = Messaging.getMessaging(app);
  return <Reactfire$1.AppCheckProvider
    sdk={appCheck}
  >
    <Reactfire$1.AnalyticsProvider
      sdk={analytics}
    >
      <Reactfire$1.AuthProvider
        sdk={auth}
      >
        <Reactfire$1.FunctionsProvider
          sdk={functions}
        >
          <Reactfire.MessagingProvider.make
            value={Primitive_option.some(messaging)}
          >
            {props.children}
          </Reactfire.MessagingProvider.make>
        </Reactfire$1.FunctionsProvider>
      </Reactfire$1.AuthProvider>
    </Reactfire$1.AnalyticsProvider>
  </Reactfire$1.AppCheckProvider>;
}

let make = FirebaseAuthProvider;

export {
  make,
}
/* Firebase Not a pure module */
